import router from '@/router/index'
import Cookies from "js-cookie"
import config from '@/config'
import * as _ from 'lodash'
import server from '@/library/api.service'
import axios from '@/library/api.request'
import {stringify} from 'qs'
import { forEach, hasOneOf, objEqual } from '@/library/tools'


/**
 * @description tok
 */
export const TOKEN_KEY = 'token'

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, {expires: 6/24})
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

export const title = (name) => {
  let pageName = name || '智维（zhiops.com), 一站式研发&运维管理平台';
  window.document.title = pageName;
}

export const showTitle = (item, vm) => {
  return item.meta.title
}

/**
 * @description 获取storage内容
 * @function localRead
 * @param {*} key
 */
export const localRead = (key) => {
  return localStorage.getItem(key) || ''
}

/**
 * 请求类型
 * @param {*} data
 * @param {*} method
 */
function typeParams (data,method) {
  let type = {}
  if (method == 'POST') {
    method = 'POST'
		type = {
			method,
			data: stringify(data)
		}
  } else if (method == 'DELETE') {
		method = 'DELETE'
		type = {
			method,
			params: {
				...data
			}
		}
	} else if (method == 'PUT') {
    method = 'PUT'
		type = {
			method,
      data: stringify(data)
		}
  } else if (method == 'PATCH') {
		method = 'PATCH'
		type = {
			method,
			data
		}
	} else {
		method = 'GET'
		type = {
			method,
			params: {
				...data
			}
		}
  }
	return type
}

export const curlHttp =(url, data, method) => {
  return axios.request({
    url: server.prefix + url,
    ...typeParams(data, method)
  })
}

/**
 * 设置cookies
 * @param name
 * @param content
 * @param time
 */
export const setCookie = (name, content, time) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  Cookies.set(name, content, time)
}

/**
 * 读取cookies
 * @param name
 * @returns {*}
 */

export const getCookie = (name) => {
  if (!name) return
  let data = Cookies.get(name)
  if (!data) {
    return false
  }
  if (typeof data !== 'string') {
    return JSON.parse(data)
  }
  return data
}

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 判断是否有效
 * @param {*} name
 */
export const hasStore = (name) => {
  if (!name) return
  let data = window.localStorage.getItem(name)
  if (!data) {
    return false
  }else{
    return true
  }
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}

const showThisMenuEle = (item, access) => {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if (_.includes(access, item.meta.access)) return true
    else return false
  } else return true
}

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = (routers, homeName = 'home') => {
  let i = -1
  let len = routers.length
  let homeRoute = {}
  while (++i < len) {
    let item = routers[i]
    if (item.children && item.children.length) {
      let res = getHomeRoute(item.children, homeName)
      if (res.name) return res
    } else {
      if (item.name === homeName) homeRoute = item
    }
  }
  return homeRoute
}

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
  let i = -1
  while (++i < times) {
    callback(i)
  }
}

/**
 * @param {Number} times 日期格式
 * @param {Function} callback 日期格式
 */
export const dateStrFormat=(dateStr, fmt) => {  
  let date = new Date(Date.parse(dateStr.replace(/-/g, "/"))) 
  return this.dateFormat(date, fmt)
}

export const dateFormat = (date, fmt) => {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));

    }
  }
  return fmt;
}


/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access)
  else return true
}

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (name, access, routes) => {
  const routePermissionJudge = (list) => {
    return list.some(item => {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children)
      } else if (item.name === name) {
        return hasAccess(access, item)
      }
    })
  }

  return routePermissionJudge(routes)
}


/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
export const getMenuByRouter = (list, access) => {
  let res = []
  forEach(list, item => {
    if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
      let obj = {
        component: item.component,
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta,
        path: item.path
      }
      if ((hasChild(item) || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access)
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href
      if (showThisMenuEle(item, access)) res.push(obj)
    }
  })
  return res
}

export const getSubMenu = (list) => {
  let res = []

  let obj = {
    component: () => import('@/views/Main.vue'),
    icon: (list.meta && list.meta.icon) || '',
    name: list.name,
    meta: list.meta,
    path: list.path
  }
  let child = list.matched
  if(child.length > 0) {
    child.forEach((item, index) => {
      if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
        let objsub = {
          component: item.component,
          icon: (item.meta && item.meta.icon) || '',
          name: item.name,
          meta: item.meta,
          path: item.path
        }
        if ((hasChild(item) || (item.meta && item.meta.showAlways))){
          objsub.children = getSubMenu(item.children, access)
        }
        if (item.meta && item.meta.href) obj.href = item.meta.href
        res.push(objsub)
      }
    })
    obj.children = res
  }
  return obj
}

export const findNodeUpperByClasses = (ele, classes) => {
  let parentNode = ele.parentNode
  if (parentNode) {
    let classList = parentNode.classList
    if (classList && classes.every(className => classList.contains(className))) {
      return parentNode
    } else {
      return findNodeUpperByClasses(parentNode, classes)
    }
  }
}


/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = (route, homeRoute) => {
  let homeItem = { ...homeRoute, icon: homeRoute.meta.icon }
  let routeMetched = route.matched
  if (routeMetched.some(item => item.name === homeRoute.name)) return [homeItem]
  let res = routeMetched.filter(item => {
    return item.meta === undefined || !item.meta.hideInBread
  }).map(item => {
    let meta = { ...item.meta }
    if (meta.title && typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      meta.title = meta.title(route)
    }
    let obj = {
      icon: (item.meta && item.meta.icon) || '',
      name: item.name,
      meta: meta
    }
    return obj
  })
  res = res.filter(item => {
    return !item.meta.hideInMenu
  })
  return [{ ...homeItem, to: homeRoute.path }, ...res]
}
/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
export const routeEqual = (route1, route2) => {
  const params1 = route1.params || {}
  const params2 = route2.params || {}
  const query1 = route1.query || {}
  const query2 = route2.query || {}
  return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
}

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
export const getNextRoute = (list, route) => {
  let res = {}
  if (list.length === 2) {
    res = getHomeRoute(list)
  } else {
    const index = list.findIndex(item => routeEqual(item, route))
    if (index === list.length - 1) res = list[list.length - 2]
    else res = list[index + 1]
  }
  return res
}

/**
 * @description 本地存储和获取标签导航列表
 */
export const setTagNavListInLocalstorage = list => {
  localStorage.tagNaveList = JSON.stringify(list)
}

/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
export const getTagNavListFromLocalstorage = () => {
  const list = localStorage.tagNaveList
  return list ? JSON.parse(list) : []
}

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
export const getNewTagList = (list, newRoute) => {
  const { name, path, meta } = newRoute
  let newList = [...list]
  if (newList.findIndex(item => item.name === name) >= 0) return newList
  else newList.push({ name, path, meta })
  return newList
}

export const getRouteTitleHandled = (route) => {
  let router = { ...route }
  let meta = { ...route.meta }
  let title = ''
  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      title = meta.title(router)
    } else title = meta.title
  }
  meta.title = title
  router.meta = meta
  return router
}

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
export const routeHasExist = (tagNavList, routeItem) => {
  let len = tagNavList.length
  let res = false
  doCustomTimes(len, (index) => {
    if (routeEqual(tagNavList[index], routeItem)) res = true
  })
  return res
}

/**
 * 判断是否有权限
 * @param {*} permission 现有权限值
 * @description 判断是否有权限
 */
export const hasPermission = (permission) => {
  let userinfo = JSON.parse(localStorage.getItem('userinfo'))
  return _.includes(userinfo.roles, permission) ? true : false;
}

/**
 * 字符串是否右边包含
 * @param string
 * @param find
 * @param lower
 * @returns {boolean}
 */
export const rightExists = (string, find, lower = false) => {
  string += "";
  find += "";
  if (lower !== true) {
    string = string.toLowerCase();
    find = find.toLowerCase();
  }
  return (string.substring(string.length - find.length) === find);
}


/**
 * 相当于 intval
 * @param str
 * @param fixed
 * @returns {number}
 */
export const runNum = (str, fixed) => {
  let _s = Number(str);
  if (_s + "" === "NaN") {
    _s = 0;
  }
  if (/^[0-9]*[1-9][0-9]*$/.test(fixed)) {
    _s = _s.toFixed(fixed);
    let rs = _s.indexOf('.');
    if (rs < 0) {
      _s += ".";
      for (let i = 0; i < fixed; i++) {
        _s += "0";
      }
    }
  }
  return _s;
}

/**
 * 将 JavaScript 值转换为 JSON 字符串（已try）
 * @param json
 * @param defaultVal
 * @returns {string}
 */
export const jsonStringify = (json, defaultVal) => {
  if (typeof json !== 'object') {
    return json;
  }
  try{
      return JSON.stringify(json);
  }catch (e) {
      return defaultVal ? defaultVal : "";
  }
}

function fillUrl(str) {
  if (str.substring(0, 2) === "//" ||
      str.substring(0, 7) === "http://" ||
      str.substring(0, 8) === "https://" ||
      str.substring(0, 6) === "ftp://" ||
      str.substring(0, 1) === "/") {
    return str;
  }
  return window.location.origin + '/' + str;
}

export const webUrl = (str) => {
  return fillUrl(str || '');
}



export const jsonParse = (str, defaultVal) => {
  if (str === null) {
    return defaultVal ? defaultVal : {};
  }
  if (typeof str === "object") {
      return str;
  }
  try {
      return JSON.parse(str);
  } catch (e) {
      return defaultVal ? defaultVal : {};
  }
}


/**
 * @description 返回日期
 */
export const getTime = () => {
  var _this = this;
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth()+1;
  let dd = new Date().getDate();
  let hh = new Date().getHours();
  let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
  let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
  return yy+'-'+mm+'-'+dd;
}


function zeroFill(str, length, after) {
  str+= "";
  if (str.length >= length) {
      return str;
  }
  let _str = '', _ret = '';
  for (let i = 0; i < length; i++) {
      _str += '0';
  }
  if (after || typeof after === 'undefined') {
      _ret = (_str + "" + str).substr(length * -1);
  } else {
      _ret = (str + "" + _str).substr(0, length);
  }
  return _ret;
}



 /**
 * 时间戳转时间格式
 * @param format
 * @param v
 * @returns {string}
 */
export const formatDate = (format, v) =>  {
  if (format === '') {
      format = 'Y-m-d H:i:s';
  }
  let dateObj;
  if (v instanceof Date) {
      dateObj = v;
  }else {
      if (typeof v === 'undefined') {
          v = new Date().getTime();
      }else if (/^(-)?\d{1,10}$/.test(v)) {
          v = v * 1000;
      } else if (/^(-)?\d{1,13}$/.test(v)) {
          v = v * 1000;
      } else if (/^(-)?\d{1,14}$/.test(v)) {
          v = v * 100;
      } else if (/^(-)?\d{1,15}$/.test(v)) {
          v = v * 10;
      } else if (/^(-)?\d{1,16}$/.test(v)) {
          v = v * 1;
      } else {
          return v;
      }
      dateObj = new Date(v);
  }
  //
  format = format.replace(/Y/g, dateObj.getFullYear());
  format = format.replace(/m/g, zeroFill(dateObj.getMonth() + 1, 2));
  format = format.replace(/d/g, zeroFill(dateObj.getDate(), 2));
  format = format.replace(/H/g, zeroFill(dateObj.getHours(), 2));
  format = format.replace(/i/g, zeroFill(dateObj.getMinutes(), 2));
  format = format.replace(/s/g, zeroFill(dateObj.getSeconds(), 2));
  return format;
}